import { css } from 'styled-components';

export const blockRightMouseStyle = css`
  -webkit-touch-callout: none;
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
`;
